(function () {
	'use strict';

	angular.module('qbePortal').directive('qbCvcNumeric',

		function () {
			var regexNumber = /^\d+$/;

			return {
				restrict: 'A',
				require: 'ngModel',
				link: function (scope, element, attrs, ngModel) {
					scope.$watch(function () {
						return ngModel.$viewValue;
					}, function (newValue, oldValue) {

						if (newValue && !regexNumber.test(newValue)) {
							ngModel.$setViewValue(oldValue);
							ngModel.$render();
						}
					});
				}
			};
		});
})();
